export const countryCodesMap = {
    sv: 'se',
    se: 'sv',
    no: 'no',
    fi: 'fi',
    da: 'dk',
    dk: 'da',
    en: 'en',
    is: 'is',
};